import React, { Fragment, useState, useEffect, useContext, createRef, useRef } from "react";
import MaxMiniSize from "./MaxMiniSize";
import UserHeader from "./UserHeader";
import { UL } from "../../../AbstractElements";
import Searchbar from "./Searchbar";
import CitySelect from "./CitySelect";
import AddNewButton from "../../../Components/Common/Component/AddNewButton";
import EditBookCab from "../../../Components/TripManagement/BookingHistory/EditBookCab";
import EditRaiseTicket from "../../../Components/Support/TicketHistory/EditRaiseTicket";
import { tmsApi } from "../../../api";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import BookingContext from "../../../_helper/Booking";
import SharedDataContext from "../../../_helper/SharedData";
import { useLocation } from "react-router-dom";
import { getUserRole, getAvatarText } from "../../../Services/Shared.service";
import { Admin, Capture, Dispatch, ShiftInCharge } from "../../../Data/SideMenu/RouteMapping";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import BookEdit from "../../../Components/TripManagement/BookingHistory/bookEdit"
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
  addWeeks
} from "date-fns";
import { DateRangePicker, defaultStaticRanges, defaultInputRanges } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from "moment";
import { Button } from "reactstrap";
import MoonLight from "./MoonLight";
import CustomerSearchModal from "./CustomerSearchModal";

const RightHeader = () => {
  const userRole = getUserRole();

  const toggleRoles = [Capture, Dispatch];

  const location = useLocation();
  const {
    onSubmitData,
    editBookCabModal,
    bookingEditType,
    setBookingEditType,
    toggleBookCabModal,
    bookingObj,
    setBookingObj,
    editRebookBookCabModal,
    bookingObjs,
    bookingEditTypes,toggleeditCabModal

  } = useContext(BookingContext);

  const {
    cityData,
    airportData,
    globalCityField,
    setShowApiLoader,
    dateFilter,
    setDateFilter
  } = useContext(SharedDataContext);

  let stompClient = null;

  const [ticketModal, setticketModal] = useState(false);
  const TicketModalToggle = () => setticketModal(!ticketModal);
  const [newCityData, setNewCityData] = useState([]);
  const [customerSearchOpen,setCustomerSearchOpen] = useState(false)
  const toggleCustomerSearch = () => setCustomerSearchOpen(!customerSearchOpen)

  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false)
  const [dateLabel, setDateLabel] = useState(dateFilter.label)
  const [startDate, setStartDate] = useState(dateFilter.startDate);
  const [endDate, setEndDate] = useState(dateFilter.endDate);
  let divDateRef = useRef()

  const customRanges = defaultStaticRanges.filter((range) => ["Today", "This Week", "This Month"].includes(range.label))

  console.log("ranges", defaultStaticRanges, defaultInputRanges)

  const handleSelect = (date) => {
    // console.log(date)
    if (date.selection.startDate !== date.selection.endDate) {
      const result = calculateDateRangeFromTwoDates(date);
      // if (result.specificTimeSpan === true)
      //   toggleRangePicker();
      console.log("result", result)
      setDateLabel(result.text)
    }
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  };

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  }

  const [toggle, setToggle] = useState(true);

  const defaultSelectValue = {
    label: "All Cities",
    value: null,
  };

  const BookingModalToggle = () => {
    if (!location.pathname.includes("/customers/customer-profile")) {
      if (localStorage.getItem("customerDetails")) {
        const customerDetails = JSON.parse(
          localStorage.getItem("customerDetails")
        );
        setBookingObj((prevData) => {
          return {
            ...prevData,
            custName: customerDetails?.customerName,
            custMobile: customerDetails?.customerNo,
            custId: customerDetails?.customerId,
            custEmail: customerDetails?.customerEmail,
            gender: customerDetails?.gender,
          };
        });
      } else {
        setBookingObj({});
      }
    }

    toggleBookCabModal();
    setBookingEditType("Book");
  };
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const agentId = userDetails?.agentId || "2001";

  const fetchBookingData = async () => { };

  const setDashboard = (toggle) => {
    setToggle(toggle)
    if (toggle) {
      // history(`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`)
    } else {

    }
  };

  const onConnected = () => {
    console.log("onConnected");
    // Subscribe to the Public Topic
    stompClient.subscribe(`/booking/czentrix/${agentId}`, onMessageReceived);
  };

  const onMessageReceived = (payload) => {
    console.log("onMessageReceived");
    let message = JSON.parse(payload.body);
    const letter = getAvatarText(message?.customerName);
    console.log(message, "message");
    // localStorage.setItem("customerDetails", payload.body);
    toast(
      () => {
        return (
          <Fragment>
            <div className="info-card">
              <div className="alert-customer-box">
                <div className="rounded-circle profile-image-box">
                  <div className="profile-image">{letter}</div>
                </div>
                <div className="customer-info">
                  <Link
                    to={`${process.env.PUBLIC_URL}/customers/customer-profile/${message.customerId}`}
                  >
                    <div className="customer-name">
                      {message?.customerName
                        ? message.customerName
                        : "New Customer"}
                    </div>
                  </Link>
                  <div className="customer-mobile">{message.customerNo}</div>
                </div>
              </div>
              <div className="alert-description">
                This person is trying to call you
              </div>
            </div>
          </Fragment>
        );
      },
      {
        position: "top-right",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "info-czentix",
      }
    );
  };

  const onError = (error) => {
    console.log("connection not established");
    console.log(error, "error");
  };

  useEffect(() => {
    const nullCity = [defaultSelectValue];
    setNewCityData((prevData) => {
      return [...nullCity, ...cityData];
    });
  }, [cityData]);

  useEffect(() => {
    const baseUrl = tmsApi.replace("api/", "tms");
    console.log(baseUrl, "baseUrl");

    let sock = new SockJS(baseUrl);
    sock.onopen = function () {
      console.log("connectionopen");
      sock.send("test");
    };
    stompClient = Stomp.over(sock);

    stompClient.connect({}, onConnected, onError);

    return () => {
      console.log("component exit connection closed");
      stompClient.disconnect();
    };
  }, []);

  const calculateDateRangeFromTwoDates = (ranges) => {
    const beginDate = moment(ranges.selection.startDate);
    const endDate = moment(ranges.selection.endDate);
    const today = moment();
    let text = '';
    let specificTimeSpan = true;
    const duration = moment.duration(endDate.diff(beginDate));
    console.log("duration", duration, duration.get('days'))
    const selectedDateDifference = duration.get('days');

    console.log("dates", moment(beginDate), moment(endDate), moment().add(1, 'days').startOf('day'), moment(beginDate).isSame(moment().add(1, 'days').startOf('day'), 'day'))

    switch (selectedDateDifference) {
      case 30:
        text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
          'DD/MM/YYYY',
        )}`;
        specificTimeSpan = false;
        break;
      case 29:
        text = moment(endDate).isSame(today, 'month') ? 'This Month' : moment(endDate).isSameOrBefore(today, 'month') ? 'Last Month' : 'Next Month';
        break;
      case 7:
        text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
          'DD/MM/YYYY',
        )}`;
        specificTimeSpan = false;
        break;
      case 6:
        text = moment(endDate).isSame(today, 'week') ? 'This Week' : moment(endDate).isSameOrBefore(today, 'week') ? 'Last Week' : 'Next Week';
        break;
      case 1:
        text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
          'DD/MM/YYYY',
        )}`;
        specificTimeSpan = false;
        break;
      case 0:
        text = moment(endDate).isSame(today, 'day') ? 'Today' : moment(endDate).isSame(today.add(-1, 'days').startOf('day'), 'day') ? 'Yesterday' : moment(beginDate).isSame(moment().add(1, 'days').startOf('day'), 'day') ? 'Tomorrow' : `${moment(ranges.selection.startDate).format('DD/MM/YYYY')}`;
        break;
      default:
        text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
          'DD/MM/YYYY',
        )}`;
        specificTimeSpan = false;
        break;
    }

    return ({
      text,
      specificTimeSpan
    })
  };

  console.log("label", dateLabel)
  // console.log("day", moment().add(1, 'days').startOf('day'), moment(new Date("2023-05-16")).isSame(moment().add(1, 'days').startOf('day'), 'day'))

  return (
    <Fragment>
      <div
        className={`nav-right col-sm-11 pull-right right-header p-0 col-lg-10`}
      >
        <UL attrUL={{ className: "nav-menus flex-row" }}>
          {/* <Searchbar /> */}

          {/* {userRole.every((element) => toggleRoles.includes(element)) ||
          userRole.some((element) => element == Admin) ? (
            <div className="custom-dashboard-toggle-switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setDashboard(!toggle);
                }}
                id="switch"
              />
              <label htmlFor="switch"></label>
            </div>
          ) : (
            ""
          )} */}

          {userRole.some(
            (element) => element == Capture || element == Admin || element == ShiftInCharge
          ) ? (
            <AddNewButton
              options={{
                name: "Book a Cab",
                icon: <i className="fa fa-car"></i>,
                onclickEvent: toggleCustomerSearch,
              }}
            >
              {editBookCabModal && (
              <EditBookCab
                LargeModaltoggle={toggleBookCabModal}
                title={"Create a new booking"}
                Large={editBookCabModal}
                cityData={cityData}
                airportData={airportData}
                onSubmitData={{
                    fetchBookingData: ()=>{
                      toggleCustomerSearch()
                      onSubmitData.fetchBookingData()
                    }
                }}
                editType={bookingEditType}
                bookingData={bookingObj}
                setShowApiLoader={setShowApiLoader}
              />
              )}

              <BookEdit
              LargeModaltoggle={toggleeditCabModal}
              title={"Create a new booking"}
              Large={editRebookBookCabModal}
              cityData={cityData}
              airportData={airportData}
              onSubmitData={{
                  fetchBookingData: ()=>{
                    toggleCustomerSearch()
                    onSubmitData.fetchBookingData()
                  }
              }}
              editType={bookingEditTypes}
              bookingData={bookingObjs}
              setShowApiLoader={setShowApiLoader}
         />
      

              <CustomerSearchModal
                LargeModaltoggle={toggleCustomerSearch}
                title={"Create a new booking"}
                Large={customerSearchOpen}
                toggleEditCabModal={toggleeditCabModal}
                toggleBookCabModal={toggleBookCabModal}
                BookingModalToggle={BookingModalToggle}
              />
            </AddNewButton>
          ) : (
            ""
          )}
          {/* <AddNewButton
            options={{
              name: "Raise a Ticket",
              icon: <i className="fa fa-ticket"></i>,
              onclickEvent: TicketModalToggle,
            }}
          >
            <EditRaiseTicket
              title={"Raise a Ticket"}
              LargeModaltoggle={TicketModalToggle}
              Large={ticketModal}
            />
          </AddNewButton> */}
          <CitySelect
            cityData={newCityData}
            globalCityField={globalCityField}
            defaultSelectValue={defaultSelectValue}
          />
          <div style={{ position: "relative" }}>
            <input className="form-control" type="text" onClick={() => setIsOpenDatePicker(true)} value={dateFilter.label} style={{ cursor: "pointer" }} />

            <div ref={divDateRef} style={{ position: "absolute", top: "60px", right: "0px", backgroundColor: "white", display: isOpenDatePicker ? "block" : "none", border: "solid 1px #cccccc", borderRadius: "10px", padding: "10px" }}>
              {/* <DefinedRange
                onChange={item => console.log("item", item)}
                ranges={state}
                renderStaticRangeLabel={renderStaticRangeLabel}
                staticRanges={[
                  {
                    label: 'Hoy',
                    hasCustomRendering: true,
                    range: () => ({
                      startDate: new Date(),
                      endDate: new Date()
                    }),
                    isSelected() {
                      return true;
                    }
                  }
                ]}
              /> */}
              <DateRangePicker
                ranges={[selectionRange]}
                onChange={handleSelect}
                minDate={addMonths(new Date(startDate), -6)}
                // maxDate={addMonths(new Date(startDate),2)}
                inputRanges={[]}
                staticRanges={[
                  defaultStaticRanges.find((range) => range.label == "Last Month"),
                  defaultStaticRanges.find((range) => range.label == "Last Week"),
                  defaultStaticRanges.find((range) => range.label == "Yesterday"),
                  defaultStaticRanges.find((range) => range.label == "Today"),
                  {
                    label: "Tomorrow",
                    range: () => ({
                      startDate: startOfDay(addDays(new Date(), 1)),
                      endDate: endOfDay(addDays(new Date(), 1))
                    }),
                    isSelected: (range) => {
                      console.log("isselected range", range)
                      const definedRange = range;
                      return (
                        isSameDay(startOfDay(addDays(new Date(), 1)), definedRange.startDate) &&
                        isSameDay(endOfDay(addDays(new Date(), 1)), definedRange.endDate)
                      );
                    }
                  },
                  {
                    label: "Next Week",
                    range: () => ({
                      startDate: startOfWeek(addWeeks(new Date(), 1)),
                      endDate: endOfWeek(addWeeks(new Date(), 1))
                    }),
                    isSelected: (range) => {
                      console.log("isselected range", range)
                      const definedRange = range;
                      return (
                        isSameDay(startOfWeek(addWeeks(new Date(), 1)), definedRange.startDate) &&
                        isSameDay(endOfWeek(addWeeks(new Date(), 1)), definedRange.endDate)
                      );
                    }
                  },
                  {
                    label: "Next Month",
                    range: () => ({
                      startDate: startOfMonth(addMonths(new Date(), 1)),
                      endDate: endOfMonth(addMonths(new Date(), 1))
                    }),
                    isSelected: (range) => {
                      console.log("isselected range", range)
                      const definedRange = range;
                      return (
                        isSameDay(startOfMonth(addMonths(new Date(), 1)), definedRange.startDate) &&
                        isSameDay(endOfMonth(addMonths(new Date(), 1)), definedRange.endDate)
                      );
                    }
                  },
                ]}
              />
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", borderTop: "solid 1px #cccccc", margin: "0px 15px", paddingTop: "5px", marginTop: "5px" }}>
                <Button color="primary" onClick={() => {
                  setDateFilter({
                    startDate: startDate,
                    endDate: endDate,
                    label: dateLabel
                  })
                  setIsOpenDatePicker(false)
                }} style={{ marginRight: "10px" }}>OK</Button>
                <Button onClick={() => setIsOpenDatePicker(false)}>Cancel</Button>
              </div>
            </div>
          </div>

          <MoonLight />
          <MaxMiniSize />
          {/* <UserHeader /> */}
        </UL>
      </div>
      {/* <SockJsClient
        url="http://43.205.86.19:8085/tms/"
        topics={[`/booking/czentrix/${agentId}`]}
        onConnect={console.log("Connection established!")}
        onDisconnect={console.log("Disconnected!")}
        onMessage={() => onMessageReceived()}
        debug={true}
      /> */}
    </Fragment>
  );
};

export default RightHeader;
